import _ from 'lodash';
import { SyntheticEvent, useEffect, useState } from 'react';
import {
  Button,
  Checkbox,
  Form,
  Grid,
  Header,
  Input,
  Radio,
  Segment,
  Select,
} from 'semantic-ui-react';
import { v4 as uuid } from 'uuid';
import DatePicker from 'react-datepicker';
import agent from '../../../app/api/agent';
import {
  validationOptions,
} from '../../../app/common/options/otherOptions/approveOptions';
import { WorkflowElement, WorkflowOptions } from '../../../app/models/template';
import { useStore } from '../../../app/stores/store';
import SettingsBarcode from '../WorkflowSettings/SettingsBarcode';
import WorkflowSettingsOptions from '../WorkflowSettings/WorkflowSettingsOptions';
import WorkflowDynamicMetaDataDropdown from '../WorkflowSettings/WorkflowDynamicMetaDataDropdown';
import { toast } from 'react-toastify';
import axios from 'axios';
import { defaultTextBoxValue, scanAreaOptions } from './constants';

interface DropDownI {
  key: string;
  value: string;
  text: string;
}

interface CommonComponentSettingsPropsI {
  needElementName?: boolean;
  isMetadata?: boolean;
  settingsOptions: any;
  selectedSetting: string;
  elementOptionDetails: DropDownI[];
  selectedElement: WorkflowElement;
  elementsArray: WorkflowElement[];
  className?: string;
  submitClassFunc: () => void;
  changeSelectOptionHandler: any;
  handleClose: () => void;
  handleSave: (payload: {
    name: string;
    value: any;
    isReadOnly: boolean;
    isMandatory: boolean;
    enableByDefault: boolean;
    parentId: string;
    optionsState: WorkflowOptions[];
    metadatatype?: string;
    isMultiple?: boolean;
    validation?: string;
    parentDynamicDetails?: {
      parentDynamicId: string;
      templateId: string;
      elementTypeId: string;
      assetTypeId: string;
    };
    selectMasterComponent: string;
    scanAreaType?: string;
    autoPopulate: string;
    metadataFromParent?: string;
  }) => void;
  scanType?: string;
}

function CommonComponentSettings(props: CommonComponentSettingsPropsI) {
  const {
    needElementName,
    isMetadata,
    selectedElement,
    elementOptionDetails,
    className,
    settingsOptions,
    selectedSetting,
    changeSelectOptionHandler,
    elementsArray,
    submitClassFunc,
    handleClose,
    handleSave,
    scanType,
  } = props;

  const {
    activityStore,
    TemplateStore,
    metaDataStore,
    workflowConfigurationStore: { WorkflowConfiguration },
    commonStore: { markLoginStaticRegisterDemoChages },
  } = useStore();

  const {
    elementId,
    elementName,
    elementType,
    elementValue,
    enableByDefault,
    parentId,
    parentDynamicDetails,
    validation,
    selectMasterComponent,
  } = selectedElement || {};

  const [localElementName, setLocalElementName] = useState(elementName);
  const [localLink, setLocalLink] = useState(elementValue);
  const [optionsState, setOptionsState] = useState<WorkflowOptions[] | []>([]);
  const [validationState, setValidationState] = useState<string>(validation);
  const [getkey, setgetkey] = useState<number | null>();
  const [defaultValue, setDefaultvalue] = useState(elementValue);
  const [isReadOnly, setIsReadOnly] = useState<boolean>(
    selectedElement.readOnly,
  );
  const [isMandatory, setIsMandatory] = useState<boolean>(
    selectedElement.isMandatory,
  );
  const [isTechnical, setIsTechnical] = useState<boolean>(false);
  const [isMultiple, setIsMultiple] = useState<boolean>(false);
  const [rolesList, setRolesList] = useState<any>([]);
  const [duplicateOptionstate, setDuplicateOptionState] = useState<
    WorkflowOptions[] | []
  >([]);
  const [openLink, setOpenLink] = useState<string>('');
  const [enableBydefaultState, setEnableBydefaultState] =
    useState<boolean>(enableByDefault);
  const [textAreaDefaultValue, setTextAreaDefaultValue] = useState<string>('');
  const [scanAreaType, setScanAreaType] = useState<string>('Neutral');
  const [textBoxDefaultValue, setTextBoxDefaultValue] = useState<string>('');
  const [autoPopulateValue, setAutoPopulateValue] = useState<string>('');
  const [dateValue, setDateValue] = useState<string>('');
  const [selectedRole, setSelectedRole] = useState({
    id: '',
    name: '',
  });
  const [mastersList, setMastersList] = useState<any>([]);
  const [mastersMetaDataList, setMastersMetaDataList] = useState<any>([]);
  const [selectedMaster, setSelectedMaster] = useState({
    id: '',
    name: '',
  });
  const [selectedMasterComp, setSelectedMasterComp] = useState({
    id: '',
    name: '',
  });
  const [selectedParent, setSelectedParent] = useState({
    id: '',
    name: '',
  });
  const [dynamicMetadataValue, setDynamicMetadataValue] = useState('');
  const [parentDynamicMetadataDetails, setParentDynamicMetadataDetails] =
    useState<{
      assetTypeId: string;
      elementTypeId: string;
      templateId: string;
      value: string;
      assetOptions: DropDownI[];
      elementOptions: DropDownI[];
      templateOptions: DropDownI[];
      isElementLoading: boolean;
      isTemplateLoading: boolean;
    }>({
      assetTypeId: '',
      elementTypeId: '',
      templateId: '',
      value: '',
      assetOptions: [],
      elementOptions: [],
      templateOptions: [],
      isElementLoading: false,
      isTemplateLoading: false,
    });
  const [enableDefaultFalseOptions, setEnableDefaultFalseOptions] = useState<
    {
      key: string;
      value: string;
      text: string;
    }[]
  >([]);
  const [dropdownTabOptions, setdropdownTabOptions] = useState<
    {
      key: string;
      value: string;
      text: string;
    }[]
  >([]);
  const [checkboxValue, setCheckboxValue] = useState('');
  const [elementTypesList, setElementTypesList] = useState<
    { key: string; text: string; value: string }[]
  >([]);
  const [metadataComponentList, setMetadataComponentList] = useState<
    { key: string; text: string; value: string }[]
  >([]);
  const [otherMetadataVal, setOtherMetadataVal] = useState<string>('');
  const [settingsList, setSettingsList] = useState([]);

  const {
    assetTypeId,
    elementTypeId,
    templateId,
    value,
    assetOptions,
    elementOptions,
    templateOptions,
    isElementLoading,
    isTemplateLoading,
  } = parentDynamicMetadataDetails || {};

  useEffect(() => {
    setLocalElementName(elementName);
    // eslint-disable-next-line
  }, [elementName]);

  useEffect(() => {
    if (markLoginStaticRegisterDemoChages) {
      settingsOptions.push({
        key: '14',
        text: 'Department',
        value: 'Department',
      });
    }
    setSettingsList(settingsOptions);
  }, [settingsOptions, markLoginStaticRegisterDemoChages]);

  useEffect(() => {
    if (scanType) setScanAreaType(scanType);
    // eslint-disable-next-line
  }, [scanType]);

  useEffect(() => {
    if (TemplateStore?.assetTypesByName) {
      let result = TemplateStore?.assetTypesByName?.map((data) => {
        return {
          key: data.id,
          value: data.typeName,
          text: data.typeName,
        };
      });
      setParentDynamicMetadataDetails((p) => ({
        ...p,
        assetOptions: result,
      }));
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setParentDynamicMetadataDetails((p) => ({
      ...p,
      isElementLoading: true,
    }));
    (async () => {
      try {
        if (assetTypeId?.split('|')?.[1]) {
          let result = await agent.ElementTypes.getElementTypeByAssetType(
            assetTypeId?.split('|')?.[1] || '',
          );
          let filter = (result || [])?.flatMap((data) => {
            return data.isDeleted
              ? []
              : {
                  key: data.id,
                  value: data.elementName,
                  text: data.elementName,
                };
          });
          setParentDynamicMetadataDetails((p) => ({
            ...p,
            elementOptions: filter,
            isElementLoading: false,
          }));
        }
      } catch {
        setParentDynamicMetadataDetails((p) => ({
          ...p,
          isElementLoading: false,
        }));
      }
    })();
  }, [assetTypeId]);

  useEffect(() => {
    setParentDynamicMetadataDetails((p) => ({
      ...p,
      isTemplateLoading: true,
    }));
    (async () => {
      try {
        if (elementTypeId?.split('|')?.[1]) {
          let result = await agent.Templates.gettemplateTypeByElementType(
            elementTypeId?.split('|')?.[1] || '',
          );
          let filter = (result || [])?.flatMap((data) => {
            return data.isDeleted
              ? []
              : {
                  key: data.templateId,
                  value: data.templateName,
                  text: data.templateName,
                };
          });
          setParentDynamicMetadataDetails((p) => ({
            ...p,
            templateOptions: filter,
            isTemplateLoading: false,
          }));
        }
      } catch {
        setParentDynamicMetadataDetails((p) => ({
          ...p,
          isTemplateLoading: false,
        }));
      }
    })();
  }, [elementTypeId]);

  useEffect(() => {
    if (elementTypeId) {
      let result = TemplateStore?.assetTypesByName?.map((data) => {
        return {
          key: data.id,
          value: data.typeName,
          text: data.typeName,
        };
      });
      setParentDynamicMetadataDetails((p) => ({
        ...p,
        assetOptions: result,
      }));
    }
    // eslint-disable-next-line
  }, [elementTypeId]);

  useEffect(() => {
    if (elementType?.toLowerCase() === 'link') {
      setOpenLink(elementValue);
    } else if (elementType?.toLowerCase() === 'textbox') {
      setTextBoxDefaultValue(elementValue);
    } else if (elementType?.toLowerCase().includes('currentuser')) {
      setAutoPopulateValue(elementType.split('|')?.[1]);
    } else if (elementType?.toLowerCase() === 'checkbox') {
      setCheckboxValue(elementValue);
    } else if (
      elementType?.toLowerCase() === 'textarea' ||
      elementType?.toLowerCase() === 'scanarea'
    ) {
      setTextAreaDefaultValue(elementValue);
    } else if (elementType?.toLowerCase() === 'datepicker') {
      setDateValue(elementValue);
    } else if (elementType === 'Dynamicmetadata') {
      setDynamicMetadataValue(elementValue);
    } else if (elementType === 'ParentDynamicmetadata') {
      setParentDynamicMetadataDetails((p) => ({
        ...p,
        assetTypeId: parentDynamicDetails?.assetTypeId || '',
        elementTypeId: parentDynamicDetails?.elementTypeId || '',
        templateId: parentDynamicDetails?.templateId || '',
        value: elementValue,
      }));
    }
    setDefaultvalue(elementValue);
    // eslint-disable-next-line
  }, [elementValue, elementId]);

  useEffect(() => {
    setEnableBydefaultState(selectedElement.enableByDefault);
    setIsReadOnly(selectedElement.readOnly);
    setIsTechnical(selectedElement.metadatatype === 'Technical' ? true : false);
    setIsMandatory(selectedElement.isMandatory);
    setIsMultiple(!!selectedElement.isMultiple);
    setValidationState(validation);
    const sortOptions = selectedElement.options.sort(function (a, b) {
      return a.optionIndex - b.optionIndex;
    });
    setOptionsState(sortOptions);
    setOtherMetadataVal(selectedElement.metadataFromParent || '');
    // eslint-disable-next-line
  }, [JSON.stringify(selectedElement)]);

  useEffect(() => {
    if (parentId) {
      let element = elementOptionDetails?.find((data) => data.key === parentId);
      if (element && !selectedParent.name)
        setSelectedParent({
          id: element.key,
          name: element.text,
        });
    }
    //eslint-disable-next-line
  }, [parentId]);

  const initialMasterAndUserDetailsHandler = () => {
    if (selectedSetting === 'Users') {
      (async () => {
        let result = await agent.Role.userListRoles();
        if (result) {
          setRolesList(
            result?.map((data: { id: string; roleName: string }) => ({
              key: data.id,
              value: data.roleName,
              text: data.roleName,
            })),
          );
        }
      })();
    } else if (selectedSetting === 'Masters') {
      (async () => {
        let result = await agent.dynamicMaster.getMasterDetailsAPI();
        if (result?.data) {
          const tempMasterList = result?.data?.map(
            (data: { masterId: string; title: string }) => ({
              key: data.masterId,
              value: data.title,
              text: data.title,
            }),
          );
          tempMasterList.push({
            key: '735c8abf-e437-4ece-8446-34798c6d8887',
            value: 'Items',
            text: 'Items',
          });
          tempMasterList.push({
            key: 'ffead0f9-0764-4751-abb5-a3f184cd2ad0',
            value: 'WorkLevel',
            text: 'WorkLevel',
          });
          setMastersList(tempMasterList);
        }
      })();
    }
  };

  useEffect(() => {
    initialMasterAndUserDetailsHandler();
    // eslint-disable-next-line
  }, [selectedSetting]);

  useEffect(() => {
    if (
      selectedSetting?.length &&
      selectedSetting?.toLocaleLowerCase() !== 'textbox'
    ) {
      setValidationState('');
    }
    // eslint-disable-next-line
  }, [selectedSetting]);

  useEffect(() => {
    if (
      selectedMaster.id === '735c8abf-e437-4ece-8446-34798c6d8887' ||
      selectedMaster.id === 'ffead0f9-0764-4751-abb5-a3f184cd2ad0'
    ) {
      setSelectedMasterComp({
        id: '',
        name: 'Title',
      });
    }
  }, [selectedMaster.id]);

  useEffect(() => {
    if (
      selectedSetting === 'Masters' &&
      selectedMaster.id &&
      selectedMaster.id !== '735c8abf-e437-4ece-8446-34798c6d8887' &&
      selectedMaster.id !== 'ffead0f9-0764-4751-abb5-a3f184cd2ad0'
    ) {
      (async () => {
        let response = await axios.get<any>(
          `/ElementTypes/GetMetadata/${selectedMaster.id}`,
        );
        if (response?.data) {
          let resultData = response?.data?.map(
            (d: { elementId: string; elementName: string }) => {
              return {
                key: d.elementId,
                text: d.elementName,
                value: d.elementName,
              };
            },
          );
          setMastersMetaDataList(resultData);
        }
      })();
    }
    // eslint-disable-next-line
  }, [selectedMaster, selectedSetting]);

  useEffect(() => {
    if (elementType === 'Masters' && selectMasterComponent) {
      let masterMetaDataID = '';
      mastersMetaDataList?.forEach((m: any) => {
        if (m.value === selectMasterComponent) {
          masterMetaDataID = m.key;
        }
      });
      setSelectedMasterComp({
        id: masterMetaDataID,
        name: selectMasterComponent,
      });
    }
  }, [selectMasterComponent, elementType, mastersMetaDataList]);

  useEffect(() => {
    if (elementType === 'Masters') {
      let masterID = '';
      mastersList?.forEach((m: any) => {
        if (m.text === elementValue) {
          masterID = m.key;
        }
      });
      setSelectedMaster({
        name: elementValue,
        id: masterID,
      });
    }
    if (elementType === 'Users') {
      setSelectedRole({
        name: elementValue,
        id: elementId,
      });
    }
    // eslint-disable-next-line
  }, [elementType, elementValue, elementId, mastersList]);

  useEffect(() => {
    let filter: any[] = [];
    let dropdownOptions: any[] = [];
    elementsArray?.forEach((x) => {
      if (x.enableByDefault === false && x.elementType !== 'Dynamicmetadata') {
        filter.push({
          key: x.elementId,
          text: x.elementName,
          value: x.elementName,
        });
      } else {
        dropdownOptions.push({
          key: x.elementId,
          text: x.elementName,
          value: x.elementName,
        });
      }
    });
    setdropdownTabOptions(dropdownOptions);
    setEnableDefaultFalseOptions(filter);
    // eslint-disable-next-line
  }, [JSON.stringify(elementsArray)]);

  const addRowHandler = async () => {
    let id = uuid();
    const newArr = {
      isSelected: false,
      optionId: id,
      optTemplateId: id,
      optionName: '',
      optionIndex: optionsState?.length,
      optionDateTime: activityStore.updateDateTime(),
      optionType: 'textBox',
      optionLinkId: '',
      optionLinkName: '',
      isActive: true,
      isDeleted: false,
    };
    let element = {
      ...(selectedElement as any),
      options: [newArr],
    };

    try {
      if ((selectedElement as any)?.metadatatype?.length > 0) {
        delete element.metadatatype;
        delete element.masterId;
        delete element.isDeleted;
        await agent.MetaDataOption.createOptionsUnderElements(element);
      } else {
        await agent.TemplateOptions.createOptionsUnderElements(element);
      }
    } catch (e) {
      console.error(e);
    }
    if (optionsState) {
      setOptionsState([...optionsState, newArr]);
    } else {
      setOptionsState([newArr]);
    }
    if (duplicateOptionstate) {
      setDuplicateOptionState([...duplicateOptionstate, newArr]);
    } else {
      setDuplicateOptionState([newArr]);
    }
  };

  const deleteRow = (
    options: WorkflowOptions,
    selectedSetting: string = 'DropDown',
  ) => {
    let localOptions: WorkflowOptions[] = Object.assign([], optionsState);
    //Find index of specific object using findIndex method.
    const objIndex = localOptions.findIndex(
      (obj) => obj.optionId === options.optionId,
    );
    //Update object's name property.
    // localOptions[objIndex].isDeleted = true;
    localOptions.splice(objIndex, 1);
    setOptionsState(localOptions);
    if ((selectedElement as any)?.metadatatype?.length) {
      metaDataStore.deleteOptions(options.optionId, selectedSetting); //deleting the option
    } else TemplateStore.deleteOptions(options.optionId, selectedSetting); //deleting the option
  };

  //set as default function
  const setDefaultValueFunction = (options: WorkflowOptions) => {
    const updatedOptionState = optionsState.map(e => ({
      ...e,
      isSelected: e.optionName === options.optionName
    }));
    setOptionsState(updatedOptionState);
    setDefaultvalue(options.optionName);
    const OptArr = { ...options, isSelected: true };
    TemplateStore.editOptions(OptArr);
  };

  const getOptionType = (
    optionId: string = '',
    optionTypeArg: string = 'textBox',
    isMulti: boolean = false,
    isDisabled: boolean = false,
    isMandatoryColumn: boolean = false,
  ) => {
    const newArr = optionsState.map((obj) => {
      if (obj.optionId === optionId) {
        let newArr = {
          ...obj,
          optionType: optionTypeArg,
          isMulti,
          isDisabled,
          isSelected: isMandatoryColumn,
        };
        return newArr;
      }
      return obj;
    });
    setOptionsState(newArr);
  };

  const handleClear = (id: any, index: number, count: number) => {
    const newArr = optionsState.map((obj) => {
      if (obj.optionId === id) {
        WorkflowConfiguration.dynamicDropdownList[id] = JSON.parse(
          obj.listOfOptions || '',
        );
        if (WorkflowConfiguration.dynamicDropdownList[id].length !== 0) {
          let tempArr = WorkflowConfiguration.dynamicDropdownList[id];
          tempArr = tempArr?.filter((data: string, i: number) => i !== index);
          WorkflowConfiguration.dynamicDropdownList[id] = tempArr;
        } else {
          let tempArr = [];
          for (var i = 0; i <= count; i++) {
            tempArr?.push('');
          }
          WorkflowConfiguration.dynamicDropdownList[id] = tempArr;
        }
        let newArr = {
          ...obj,
          listOfOptions: JSON.stringify(
            WorkflowConfiguration.dynamicDropdownList[id],
          ),
        };
        return newArr;
      }
      return obj;
    });
    setOptionsState(newArr);
  };

  const getAssetId = (assetName: string) => {
    let assetId = '';
    metaDataStore.assetTypesDropdownList?.forEach((asset) => {
      if (asset.value === assetName) {
        assetId = asset.key;
        return;
      }
    });
    return assetId;
  };

  const getElementTypeId = (elementTypeName: string) => {
    let elementTypeId = '';
    metaDataStore.elementTypeDropdownList?.forEach((elemnt) => {
      if (elemnt.value === elementTypeName) {
        elementTypeId = elemnt.key;
        return;
      }
    });
    return elementTypeId;
  };

  useEffect(() => {
    const tempArr = otherMetadataVal?.split('|');
    if (tempArr[0]) {
      const tempAssetId = getAssetId(tempArr[0]);
      metaDataStore.loadMetaDataATById(tempAssetId);
    }
    if (tempArr[1]) {
      const tempElementTypeId = getElementTypeId(tempArr[1]);
      metaDataStore.loadMetaDataETById(tempElementTypeId);
    }
    // eslint-disable-next-line
  }, [otherMetadataVal]);

  useEffect(() => {
    setElementTypesList(metaDataStore.elementTypeDropdownList);
    // eslint-disable-next-line
  }, [metaDataStore.elementTypeDropdownList]);

  const handleAssetTypeChange = async (_e: any, data: any) => {
    if (data.value !== '') {
      const assetId = getAssetId(data.value);
      await metaDataStore.loadMetaDataATById(assetId);
      setElementTypesList(metaDataStore.elementTypeDropdownList);
      setOtherMetadataVal(data.value);
    } else {
      setElementTypesList([]);
      setOtherMetadataVal('');
    }
  };

  useEffect(() => {
    setMetadataComponentList(metaDataStore.componentsDropdownList);
  }, [metaDataStore.componentsDropdownList]);

  const handleElementTypeChange = async (_e: any, data: any) => {
    const tempArr = otherMetadataVal?.split('|');
    let tempVal = '';
    if (data.value !== '') {
      const elementTypeId = getElementTypeId(data.value);
      await metaDataStore.loadMetaDataETById(elementTypeId);
      setMetadataComponentList(metaDataStore.componentsDropdownList);
      tempVal = `${tempArr[0]}|${data.value}`;
    } else {
      setMetadataComponentList([]);
      tempVal = `${tempArr[0]}`;
    }
    setOtherMetadataVal(tempVal);
  };

  const handleComponentChange = async (_e: any, data: any) => {
    const tempArr = otherMetadataVal?.split('|');
    let tempVal = '';
    if (data.value !== '') {
      // let tempEleId = '';
      // metaDataStore.selectedMetaDataET?.metadata?.forEach(
      //   (te: MetaDataElement) => {
      //     if (te.elementName === data.value) {
      //       tempEleId = te.templateElementId;
      //     }
      //   },
      // );
      tempVal = `${tempArr[0]}|${tempArr[1]}|${data.value}`;
    } else {
      tempVal = `${tempArr[0]}|${tempArr[1]}`;
    }
    setOtherMetadataVal(tempVal);
  };

  const addOptionRow = (id: any) => {
    const newArr = optionsState.map((obj) => {
      if (obj.optionId === id) {
        if (WorkflowConfiguration.dynamicDropdownList[id] === undefined) {
          WorkflowConfiguration.dynamicDropdownList[id] = [];
        }
        WorkflowConfiguration.dynamicDropdownList[id]?.push('');

        let newArr = {
          ...obj,
          listOfOptions: JSON.stringify(
            WorkflowConfiguration.dynamicDropdownList[id],
          ),
        };
        return newArr;
      }
      return obj;
    });
    setOptionsState(newArr);
  };

  const handleAddDropdownOptions = (
    _e: SyntheticEvent,
    data: any,
    id: any,
    index: number,
  ) => {
    const newArr = optionsState.map((obj) => {
      if (obj.optionId === id) {
        if (WorkflowConfiguration.dynamicDropdownList[id] === undefined) {
          WorkflowConfiguration.dynamicDropdownList[id] = [];
          WorkflowConfiguration.dynamicDropdownList[id].push(data.value);
        } else {
          const tempArr = WorkflowConfiguration.dynamicDropdownList[id];
          if (tempArr[index] === undefined) {
            tempArr?.push(data.value);
          } else {
            tempArr[index] = data.value;
          }
          WorkflowConfiguration.dynamicDropdownList[id] = [...tempArr];
        }
        let newArr = {
          ...obj,
          listOfOptions: JSON.stringify(
            WorkflowConfiguration.dynamicDropdownList[id],
          ),
        };
        return newArr;
      }
      return obj;
    });
    setOptionsState(newArr);
  };

  const handleAddOptionName = (
    e: any,
    data: any,
    id: string,
    type: string,
    optType: string = 'textbox',
  ) => {
    const newArr = optionsState.map((obj) => {
      if (obj.optionId === id && type === 'Input') {
        let newArr = { ...obj, optionName: data.value };
        // setEditOptionData(newArr);
        return newArr;
      }
      if (obj.optionId === id && type === 'DynamicTable') {
        //  const tempOption = optionType !== '' ? optionType : optType;
        let newArr = { ...obj, optionName: data.value, optionType: optType };
        // setEditOptionData(newArr);
        return newArr;
      }

      if (obj.optionId === id && type === 'DropDown') {
        if (e.target.className === 'delete icon') {
          const splitName = () => {
            let split = obj?.optionLinkName?.split('|') || [];
            return split;
          };
          let findIndex = splitName()?.findIndex(
            (data) => data === e.currentTarget.parentElement.text,
          );
          let filteredIds = obj?.optionLinkId?.split('|') || [];
          filteredIds?.splice(findIndex, 1);
          let name = splitName()
            ?.filter((d) => d !== e.currentTarget.parentElement.text)
            .join('|');
          return {
            ...obj,
            optionLinkName: name,
            optionLinkId: filteredIds?.join('|'),
          };
        } else {
          let removedEmptyString = data.value?.filter((item: string) => item);
          let splitNameOptions = removedEmptyString?.join('|');
          // get elementId
          if (!obj?.optionLinkName) {
            const { value } = data;
            let key = (data.options || [])?.filter(function (localData: any) {
              return localData.value === (value?.[0] || value?.[1]);
            })?.[0];
            if (key?.value === (value?.[0] || value?.[1])) {
              let filteredValues = [];
              filteredValues = (elementsArray || [])?.flatMap((localData) => {
                return localData.elementName === key.value
                  ? localData.templateElementId
                  : [];
              });
              let x = {
                ...obj,
                optionLinkId: filteredValues?.[0] || '',
                optionLinkName: splitNameOptions,
              };
              return x;
            }
          } else {
            const { value } = data;
            let key = (value || [])?.filter(function (localData: any) {
              return (
                (obj?.optionLinkName?.split('|') || []).indexOf(localData) ===
                -1
              );
            })?.[0];
            let filteredValues = [];
            filteredValues = (elementsArray || [])?.flatMap((localData) => {
              return localData.elementName === key
                ? localData.templateElementId
                : [];
            });
            let optionLinkId =
              obj.optionLinkId + '|' + (filteredValues?.[0] || '');
            let newArrUniqueId = _.uniq(optionLinkId.split('|'));
            let newUniqJOined = newArrUniqueId.join('|');
            let optionLinkName = splitNameOptions + '|' + obj.optionLinkName;
            let newArrUniqueName = _.uniq(optionLinkName.split('|'));
            let newUniqJOinedName = newArrUniqueName.join('|');
            let x = {
              ...obj,
              optionLinkId: newUniqJOined,
              optionLinkName: newUniqJOinedName,
            };
            return x;
          }
        }
      }
      return obj;
    });

    const newArr2 = duplicateOptionstate?.map((obj) => {
      if (obj.optionId === id && type === 'Input') {
        return { ...obj, optionName: data.value };
      }
      return obj;
    });

    setOptionsState(newArr as any);
    setDuplicateOptionState(newArr2);
  };

  const saveHandler = () => {
    let value = '';
    let error = '';

    switch (selectedSetting?.toLowerCase()) {
      case 'dropdown':
        let filter = optionsState?.filter((d) => !d.optionName?.length);
        if (filter?.length) {
          error = 'Please fill the options';
        }
        break;
      case 'checkbox':
        value = checkboxValue;
        break;
      case 'link':
        value = localLink;
        break;
      case 'textbox':
        value = textBoxDefaultValue;
        break;
      case 'textarea':
      case 'scanarea':
        value = textAreaDefaultValue;
        break;
      case 'masters':
        value = selectedMaster.name;
        break;
      case 'users':
        value = selectedRole.name;
        break;
      case 'datepicker':
        value = dateValue;
        break;
      case 'dynamicmetadata':
        value = dynamicMetadataValue;
        break;
      case 'parentdynamicmetadata':
        value = parentDynamicMetadataDetails.value || '';
        break;
      default:
        break;
    }

    if (selectedSetting?.includes('CurrentUser')) {
      value = '';
    }

    if (error.length) {
      toast.info(error);
      return;
    }

    let payload = {
      name: localElementName || elementName,
      value,
      isReadOnly,
      isMandatory: selectedSetting?.includes('CurrentUser')
        ? false
        : isMandatory,
      isMultiple,
      enableByDefault: enableBydefaultState,
      parentId: selectedParent.id,
      metadatatype: isTechnical ? 'Technical' : 'Metadata',
      parentDynamicDetails: {
        elementTypeId,
        assetTypeId,
        templateId,
        parentDynamicId: uuid(),
      },
      optionsState,
      validation: validationState,
      selectMasterComponent: selectedMasterComp.name,
      scanAreaType:
        selectedSetting?.toLowerCase() === 'scanarea' ? scanAreaType : '',
      autoPopulate: selectedSetting?.toLowerCase().includes('currentuser')
        ? autoPopulateValue
        : '',
      metadataFromParent: otherMetadataVal,
    };
    handleSave(payload);
  };

  return (
    <>
      <Header
        clearing="true"
        icon="edit"
        size="huge"
        dividing
        as="h1"
        content="Settings"
        sub
        color="grey"
      />
      <Segment>
        <Form className={className}>
          {needElementName && (
            <Form.Field
              control={Input}
              placeholder="Name"
              value={localElementName}
              onChange={(_e: SyntheticEvent, data: any) =>
                setLocalElementName(data.value)
              }
            />
          )}
          <Form.Field
            style={{ zIndex: '999' }}
            id="Type"
            options={settingsList}
            control={Select}
            placeholder="--Select--"
            clearable
            value={
              selectedSetting?.includes('CurrentUser')
                ? selectedSetting?.split('|')?.[0]
                : selectedSetting
            }
            onChange={changeSelectOptionHandler}
          />
          {selectedSetting === 'link' && (
            <>
              <Form.Field
                control={Input}
                placeholder="www.vms-sandbox.com"
                value={localLink}
                onChange={(_e: SyntheticEvent, data: any) =>
                  setLocalLink(data.value)
                }
              />
            </>
          )}
          {selectedSetting === 'TextBox' && (
            <>
              <Form.Field
                id="Type"
                control={Input}
                placeholder="Default Value"
                value={textBoxDefaultValue}
                onChange={(e: SyntheticEvent, data: any) =>
                  setTextBoxDefaultValue(data.value)
                }
              />
              <Form.Field
                id="Type"
                options={validationOptions}
                control={Select}
                placeholder="Validation/Path"
                value={validationState}
                onChange={(e: SyntheticEvent, data: any) =>
                  setValidationState(data.value)
                }
              />
            </>
          )}
          {/* This checkbox for reference */}

          {/* {selectedSetting === 'checkbox' && (
            <Form.Field
              options={checkboxSettingsOptions}
              control={Select}
              placeholder="Select Purpose"
              clearable
              value={checkboxValue}
              onChange={(_e: any, { value }: { value: string }) => {
                setCheckboxValue(value);
              }}
            />
          )} */}

          {selectedSetting === 'TextArea' || selectedSetting === 'ScanArea' ? (
            <>
              {selectedSetting === 'ScanArea' && (
                <Form.Field
                  control={Select}
                  placeholder={'Select Type of Scan Area'}
                  options={scanAreaOptions}
                  clearable
                  value={scanAreaType}
                  onChange={(e: SyntheticEvent, data: any) =>
                    setScanAreaType(data.value)
                  }
                />
              )}
              <Form.Field
                id="Type"
                control={Input}
                placeholder="Default Value"
                value={textAreaDefaultValue}
                onChange={(e: SyntheticEvent, data: any) =>
                  setTextAreaDefaultValue(data.value)
                }
              />
            </>
          ) : null}
          {selectedSetting === 'metadataFromParent' ? (
            <>
              <Form.Field
                label={'Select Asset Type'}
                control={Select}
                placeholder={'Select Asset Type'}
                clearable
                fluid
                search
                selection
                options={metaDataStore.assetTypesDropdownList}
                onChange={(_e: any, data: any) =>
                  handleAssetTypeChange(_e, data)
                }
                value={otherMetadataVal?.split('|')?.[0]}
              />
              <Form.Field
                label={'Select Element Type'}
                control={Select}
                placeholder={'Select Element Type'}
                clearable
                fluid
                search
                selection
                options={elementTypesList}
                onChange={(_e: any, data: any) => {
                  handleElementTypeChange(_e, data);
                }}
                value={otherMetadataVal?.split('|')?.[1] || ''}
              />
              <Form.Field
                label={'Select Component'}
                control={Select}
                placeholder={'Select Component'}
                clearable
                fluid
                search
                selection
                options={metadataComponentList}
                onChange={(_e: any, data: any) => {
                  handleComponentChange(_e, data);
                }}
                value={otherMetadataVal?.split('|')?.[2] || ''}
              />
            </>
          ) : null}
          {selectedSetting === 'DatePicker' ? (
            <>
              <DatePicker
                showMonthYearDropdown
                value={dateValue?.length ? dateValue : undefined}
                selected={
                  dateValue?.length
                    ? new Date(
                        `${dateValue.split('/')[1]}/${
                          dateValue.split('/')[0]
                        }/${dateValue.split('/')[2]}`,
                      )
                    : null
                }
                placeholderText="Select default date"
                className={'datePickerComponent'}
                dateFormat="dd/MM/yyyy"
                scrollableYearDropdown
                onChange={(date: any) => {
                  setDateValue(
                    date.toLocaleDateString('en-IN', {
                      month: '2-digit',
                      day: '2-digit',
                      year: 'numeric',
                    }),
                  );
                }}
              />
            </>
          ) : null}
          {selectedSetting === 'DropDown' ||
          selectedSetting === 'DynamicTable' ||
          selectedSetting === 'dropdownWithTab' ||
          selectedSetting === 'tab' || 
          selectedSetting === 'Checkbox' ? (
            <>
              <Grid>
                <Grid.Row columns={2}>
                  <Grid.Column width={12}>
                    <Form.Field
                      label="Title"
                      control={Input}
                      placeholder="Add Title"
                      value={localElementName}
                      readOnly={true}
                      // onChange={() => }
                    />
                  </Grid.Column>
                  <Grid.Column
                    width={4}
                    style={{
                      display: 'flex',
                      alignItems: 'end',
                    }}
                  >
                    <Button
                      style={{
                        width: '100%',
                        height: '38px',
                      }}
                      onClick={addRowHandler}
                      icon="plus"
                      positive
                      size="small"
                      content={
                        selectedSetting === 'DynamicTable'
                          ? 'Add Headers'
                          : 'Add Option'
                      }
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <Grid.Column>
                {optionsState?.map((options, index) => {
                  return (
                    <>
                      {!options?.isDeleted ? (
                        <WorkflowSettingsOptions
                          index={index}
                          isSelected={options.isSelected}
                          setgetkey={setgetkey}
                          // optionsState={optionsState}
                          handleAddOptionName={handleAddOptionName}
                          options={options}
                          defaultValue={defaultValue}
                          setDefaultValueFunction={setDefaultValueFunction}
                          getkey={getkey}
                          deleteRow={deleteRow}
                          openLink={openLink}
                          setOpenLink={setOpenLink}
                          dropdownOptions={
                            selectedSetting === 'dropdownWithTab' ||
                            selectedSetting === 'tab'
                              ? dropdownTabOptions
                              : enableDefaultFalseOptions
                          }
                          selectedSetting={selectedSetting}
                          getOptionType={getOptionType}
                          handleAddDropdownOptions={handleAddDropdownOptions}
                          handleClear={handleClear}
                          addOptionRow={addOptionRow}
                        />
                      ) : (
                        <></>
                      )}
                    </>
                  );
                })}
              </Grid.Column>
            </>
          ) : null}
          {selectedSetting === 'Barcode' && <SettingsBarcode />}
          {selectedSetting === 'Users' && (
            <Form.Field
              options={rolesList}
              control={Select}
              placeholder="Choose Users"
              clearable
              value={selectedRole.name}
              onChange={(_e: any, { value }: { value: string }) => {
                setSelectedRole({
                  id:
                    rolesList?.find(
                      (data: { value: string }) => data.value === value,
                    )?.key || '',
                  name: value,
                });
              }}
            />
          )}
          {selectedSetting === 'Masters' && (
            <>
              <Form.Field
                // style={{zIndex: "999"}}
                id="masters-type"
                options={mastersList}
                control={Select}
                placeholder="Choose Masters"
                clearable
                value={selectedMaster.name}
                onChange={(_e: any, { value }: { value: string }) => {
                  setSelectedMaster({
                    id:
                      mastersList?.find(
                        (data: { value: string }) => data.value === value,
                      )?.key || '',
                    name: value,
                  });
                }}
              />
              {selectedMaster.id !== '735c8abf-e437-4ece-8446-34798c6d8887' &&
                selectedMaster.id !==
                  'ffead0f9-0764-4751-abb5-a3f184cd2ad0' && (
                  <Form.Field
                    options={mastersMetaDataList}
                    control={Select}
                    placeholder="Choose Master MetaData"
                    clearable
                    value={selectedMasterComp.name}
                    onChange={(_e: any, { value }: { value: string }) => {
                      setSelectedMasterComp({
                        id:
                          mastersMetaDataList?.find(
                            (data: { value: string }) => data.value === value,
                          )?.key || '',
                        name: value,
                      });
                    }}
                  />
                )}
            </>
          )}
          {selectedSetting.split('|')?.[0] === 'CurrentUser' && (
            <Form.Field
              control={Select}
              placeholder={'Set Auto Populate'}
              options={defaultTextBoxValue}
              clearable
              value={autoPopulateValue}
              onChange={(e: SyntheticEvent, data: any) =>
                setAutoPopulateValue(data.value)
              }
            />
          )}
          {selectedSetting === 'Dynamicmetadata' && (
            <WorkflowDynamicMetaDataDropdown
              placeholder={'Select Dynamic Metadata'}
              type={'Dynamicmetadata'}
              apiParamsDetails={{
                templateId: TemplateStore?.selectedTemplate?.templateId || '',
                subTaskId: TemplateStore?.selectedSubTasks?.subTaskId || '',
                elementTypeId: TemplateStore?.selectedElementTypes?.id || '',
              }}
              value={dynamicMetadataValue}
              onChangeHandler={(data) => {
                setDynamicMetadataValue(data);
              }}
            />
          )}
          {selectedSetting === 'ParentDynamicmetadata' && (
            <>
              <ParentDynamicComponent
                label={'Select Asset type'}
                value={assetTypeId?.split('|')?.[0] || ''}
                options={assetOptions}
                onchange={(data: { name: string; id: string }) =>
                  setParentDynamicMetadataDetails((p) => ({
                    ...p,
                    assetTypeId: data?.name?.length
                      ? `${data.name}|${data.id}`
                      : ``,
                    elementTypeId: '',
                    templateId: '',
                    value: '',
                  }))
                }
              />
              {!!assetTypeId?.length && (
                <ParentDynamicComponent
                  label={'Select Element type'}
                  value={elementTypeId?.split('|')?.[0] || ''}
                  options={elementOptions}
                  loading={isElementLoading}
                  onchange={(data: { name: string; id: string }) =>
                    setParentDynamicMetadataDetails((p) => ({
                      ...p,
                      elementTypeId: data?.name?.length
                        ? `${data.name}|${data.id}`
                        : ``,
                      templateId: '',
                      value: '',
                    }))
                  }
                />
              )}
              {!!assetTypeId?.length && !!elementTypeId?.length && (
                <ParentDynamicComponent
                  label={'Select Template type'}
                  value={templateId?.split('|')?.[0] || ''}
                  options={templateOptions}
                  loading={isTemplateLoading}
                  onchange={(data: { name: string; id: string }) =>
                    setParentDynamicMetadataDetails((p) => ({
                      ...p,
                      templateId: data?.name?.length
                        ? `${data.name}|${data.id}`
                        : ``,
                      value: '',
                    }))
                  }
                />
              )}
              {!!templateId?.length && (
                <WorkflowDynamicMetaDataDropdown
                  placeholder={'Select Parent Dynamic Metadata'}
                  type={'ParentDynamicmetadata'}
                  apiParamsDetails={{
                    id: uuid(),
                    templateId: templateId?.split('|')?.[1] || '',
                    elementTypeId: elementTypeId?.split('|')?.[1] || '',
                    subTaskId: TemplateStore?.selectedSubTasks?.subTaskId || '',
                  }}
                  value={value || ''}
                  onChangeHandler={(value) => {
                    setParentDynamicMetadataDetails((p) => ({
                      ...p,
                      value: value?.length ? value : ``,
                    }));
                  }}
                />
              )}
            </>
          )}
          {selectedSetting !== 'Parent' && (
            <>
              <Form.Field
                style={{ position: 'relative' }}
                id="parent-type"
                options={elementOptionDetails}
                control={Select}
                placeholder="Select Parent"
                search
                clearable
                value={selectedParent.name}
                onChange={(_e: any, { value }: { value: string }) => {
                  setSelectedParent({
                    id:
                      elementOptionDetails?.find((data) => data.value === value)
                        ?.key || '',
                    name: value,
                  });
                  // if(elements && !value) elements.parentId = "";
                }}
              />
            </>
          )}
          {selectedSetting !== 'Parent' && (
            <>
              <Radio
                style={{ marginLeft: '10px' }}
                label="Enable by default"
                slider
                checked={enableBydefaultState}
                onChange={(_e: SyntheticEvent, data: any) =>
                  setEnableBydefaultState(data.checked)
                }
              />
              <br />
              <div style={{ display: 'flex', gap: '10px' }}>
                {(selectedSetting === 'DropDown' ||
                  selectedSetting === 'Masters' ||
                  selectedSetting === 'Users') && (
                  <>
                    <Checkbox
                      label="Multiple"
                      style={{ marginLeft: '10px' }}
                      checked={isMultiple}
                      onChange={(_e: SyntheticEvent, data: any) =>
                        setIsMultiple(data.checked)
                      }
                    />
                    <br />
                  </>
                )}
                {isMetadata && (
                  <>
                    <Checkbox
                      label="Technical"
                      style={{ marginLeft: '10px' }}
                      checked={isTechnical}
                      onChange={(_e: SyntheticEvent, data: any) =>
                        setIsTechnical(data.checked)
                      }
                    />
                    <br />
                  </>
                )}
                {!selectedSetting?.includes('CurrentUser') && (
                  <Checkbox
                    label="Mandatory"
                    style={{ marginLeft: '10px' }}
                    checked={isMandatory}
                    onChange={(_e: SyntheticEvent, data: any) =>
                      setIsMandatory(data.checked)
                    }
                  />
                )}
                {!selectedSetting?.includes('CurrentUser') && (
                  <div style={{ margin: '0px 0px 0px 10px' }}>
                    <Checkbox
                      checked={isReadOnly}
                      label="Read Only"
                      onChange={(_e: SyntheticEvent, data: any) =>
                        setIsReadOnly(data.checked)
                      }
                    />
                  </div>
                )}
              </div>
            </>
          )}
        </Form>
      </Segment>
      <Button.Group floated="right">
        <Button onClick={handleClose}>Cancel</Button>
        <Button.Or />
        <Button positive style={submitClassFunc()} onClick={saveHandler}>
          Save
        </Button>
      </Button.Group>
      <br />
    </>
  );
}

function ParentDynamicComponent({
  options,
  value,
  onchange,
  label,
  isDisabled,
  loading,
}: any) {
  return (
    <Form.Field
      loading={loading}
      disabled={isDisabled}
      options={options}
      control={Select}
      placeholder={label}
      search
      clearable
      value={value}
      onChange={(_e: any, { value }: { value: string }) => {
        let key =
          options?.find((data: { value: string }) => data.value === value)
            ?.key || '';
        if (key === 'Sorry, No data') return;
        onchange({
          id: key,
          name: value,
        });
      }}
    />
  );
}

export default CommonComponentSettings;
